import { useTranslation } from '@lyearn/i18n';
import { DateTagType } from '@/types/schema';

import { DateValue } from '../../types';
import TagDatePicker from '../TagDatePicker';
import ActionButton from './ActionButton';
import { TagsValueSelectorProps } from './types';
import { getDateTagPlaceholder } from './utils';

function DateSelect(props: TagsValueSelectorProps) {
  const { t } = useTranslation();
  const { className, tag, selectedTagValue, onChange, onDelete, error, readOnly, children } = props;
  const dateTag = tag as DateTagType;
  const dateTagValue = selectedTagValue as DateValue;
  const { includeEndDate, includeTime } = dateTag;

  return (
    <TagDatePicker
      includeEndDate={includeEndDate}
      includeTime={includeTime}
      selectedTagValue={selectedTagValue}
      showActionButtons={false}
      onChange={onChange}>
      {children || (
        <ActionButton
          className={className}
          defaultPlaceholder={t('Tags:Form.SelectValue')}
          error={error}
          readOnly={readOnly}
          selectedTagValue={getDateTagPlaceholder(dateTag, dateTagValue)}
          tag={tag}
          onDelete={onDelete}
        />
      )}
    </TagDatePicker>
  );
}

export default DateSelect;
